import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";

import { App } from "@/app/App";
import { joinTabs } from "@/shared/auth/session";
import { initI18n } from "@/shared/i18n/instance";
import { initTheme } from "@/shared/theme/theme";

// The tokens, and the one face of the interface (self-hosted: ./styles/fonts.css).
import "@/styles/tailwind.css";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("#root is missing from index.html");
}

initTheme();
initI18n();

// Another tab of this browser may already be signed in: take its session
// before the first route guard decides where to send the person.
void joinTabs().then(() => {
  createRoot(rootElement).render(
    <StrictMode>
      <Suspense fallback={null}>
        <App />
      </Suspense>
    </StrictMode>,
  );
});
